import React, { Component } from 'react';
import { observer } from 'mobx-react';

// From Elements folder
import {
  Text,
} from '../../elements';

import {
  Wrapper,
  SignOff,
  Credits,
  SectionTrending,
  HelpShape,
  HeadingOneCenteredSpecial,
} from './style';

import LystLogo from '../LystLogo';
import SiteCredit from '../SiteCredit';
import TrendingSearchCloud from '../TrendingSearchCloud';

import AppState from '../../states/AppState';

class Footer extends Component {

  position(scrollTop, windowHeight, bodyHeight) {
    if (scrollTop > (bodyHeight - (windowHeight * 2))) {
      return 'opacity-full';
    } else {
      return 'opacity-zero';
    }
  }

  render() {
    const { data } = AppState;
    const { trending } = data.sections;

    return (
      <Wrapper position={this.position(AppState.scrollTop, AppState.windowHeight, AppState.bodyHeight)}>
        <SignOff>
          <LystLogo />
        </SignOff>
        <HelpShape>
            <p>Help shape 2018’s Year in Fashion.
            <br/>Start your search on <a href="https://www.lyst.com/" target="_blank">Lyst</a>.</p>
        </HelpShape>
        <HeadingOneCenteredSpecial>{trending.heading}</HeadingOneCenteredSpecial>
        <TrendingSearchCloud />
      </Wrapper>
    );
  }
}

export default observer(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js